import { faCheck, faChartArea, faCircleQuestion, faXmark, faMessagesQuestion, faSitemap } from '@fortawesome/pro-solid-svg-icons';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './retakeResultsModal.scss';
import Modal from '../../../../../../../components/Modal/index';
import { useNavigate } from 'react-router-dom';
import { faCalendarAlt, faClockRotateLeft, faUserMinus } from '@fortawesome/free-solid-svg-icons';
import DateTimePicker from 'react-datetime-picker/dist/DateTimePicker';
import {useGetRetakeResultMutation, useGetSessionDatesMutation, useTriggerManualRetakeMutation, useUnassignRetakeMutation, useUpdateSessionDatesMutation } from '../../../../../../../features/authentication/assignmentRetakeApislice';
import TableSkeleton from '../../../../../../../components/SkeletonLoader/TableSkeleton';
import Skeleton from 'react-loading-skeleton';
import CustomToast from '../../../../../../../components/Toast';
import ConfirmationModal from '../../../../../../../components/ConfirmationPopUp';
import { DateFormatter } from '../../../../../../../utils/DateFormatter';
import { Tooltip as ReactTooltip } from 'react-tooltip';

function RetakesModal({isOpen, onClose, studentId, studentName, classId, className, retryCreditId, accumulatedRetake, accumulatedScorePercentage, originalAssignmentId, calculateOriginalScore}) {
  const [showPoints, setShowPoints] = useState(true);
  const navigate = useNavigate();
  const [getRetakeResult, retakeResultStatus] = useGetRetakeResultMutation();
  const [getSessionDates, getDateStatus] = useGetSessionDatesMutation();
  const [updateSessionDates, updateDateStatus] = useUpdateSessionDatesMutation();
  const [unassignRetake, unassignRetakeStatus] = useUnassignRetakeMutation();
  const [triggerManualRetake, triggerManualRetakeStatus] = useTriggerManualRetakeMutation();
  const [retakeResult, setRetakeResult] = useState([]);
  const [showDateChangeModal, setShowDateChangeModal] = useState(false);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [canChangeDate, setCanChangeDate] = useState(false);
  const [canUnassign, setCanUnassign] = useState(false);
  const [canManuallyAssign, setCanManuallyAssign] = useState(false);
  const [openUnAssignConfirmationModal, setOpenUnAssignConfirmationModal] = useState(false);
  const [openManullyAssignConfirmationModal, setOpenManullyAssignConfirmationModal] = useState(false);

  useEffect(() => {
    loadRetakeResults();
  }, []);

  const loadRetakeResults = async () => {
    var response = await getRetakeResult({ assignmentId: originalAssignmentId, studentId: studentId }).unwrap();
    calculateScore(response);
  };

  useEffect(() => {
    calculateScore(retakeResult);
  }, [showPoints]);

  const calculateScore = (retakeResults) => {
    setRetakeResult(
      retakeResults.map(item => {
        const originalScore = calculateOriginalScore(item,showPoints);
        return {
          ...item,
          displayScore:originalScore.displayScore,
          score: originalScore.score
        };
      })
    );
  };

  useEffect(() => {
    if (!retakeResult || retakeResult.length==0) return;

    const CheckCanChangeDate = ()=>{
      var originalAssignment = retakeResult.filter(x=>(!x.retakeVersion || x.retakeVersion == 0) &&  x.retakeAvailability == 'From/To' && x.retakeMode != 'Review');
      var retakeAssignment = retakeResult.filter(x=>x.retakeVersion > 0 &&  x.dateCompleted == null);
      setCanChangeDate(originalAssignment.length > 0 && retakeAssignment.length > 0);
    };

    const CheckCanUnassign = ()=>{
      var retakeAssignment = retakeResult.filter(x=>x.retakeVersion > 0 && x.dateCompleted == null);
      setCanUnassign(retakeAssignment.length > 0);
    };

    const CheckCanManuallyAssign = ()=>{
      var originalAssignment = retakeResult.find(x=>(!x.retakeVersion || x.retakeVersion == 0));
      if(originalAssignment?.availability == 'From/To' || originalAssignment?.timed)
      {
        var retakeAssignment = retakeResult.filter(x=>x.sessionId != -1 && x.dateCompleted == null && !x.retakeIssued && x.locked != 'Review' && !x.retakeLimitReached 
          &&(!x.timed || (originalAssignment.assignmentId == x.assignmentId && originalAssignment?.availability == 'From/To') || (originalAssignment.assignmentId != x.assignmentId && originalAssignment?.retakeAvailability == 'From/To') || (x.timed && x.timedOut)));       
        setCanManuallyAssign(retakeAssignment.length > 0);
      }
    };
  
    CheckCanChangeDate();
    CheckCanUnassign();
    CheckCanManuallyAssign();
  }, [retakeResult]);

  const fromDateOnChange = (value) => {
    if (value === null) {
      setFromDate();
    } else {
      setFromDate(value);
    }
  };

  const toDateOnChange = (value) => {
    if (value === null) {
      setToDate();
    } else {
      setToDate(value);
    }
  };

  const handleChangeDateClick = async () => {
    setShowDateChangeModal(true);

    var assignmentId = [...retakeResult].sort((a, b) => b.retakeVersion - a.retakeVersion)[0].assignmentId;
    var result = await getSessionDates({ assignmentId: assignmentId, studentId: studentId }).unwrap();
    setFromDate(new Date(result.startDate));
    setToDate(new Date(result.endDate));
  };

  const handleDateChangeSave = async () => {
    var result = await updateSessionDates({ 
      assignmentId: [...retakeResult].sort((a, b) => b.retakeVersion - a.retakeVersion)[0].assignmentId,
      studentId: studentId,
      startDate: fromDate,
      endDate: toDate
    });
    if (result.error)
    { 
      if(result.error.data)
        CustomToast(result.error.data.error, 'error');
      else
        CustomToast('Failed to update session dates', 'error');
      return;
    }
    CustomToast('From/To dates changed ', 'success');
    setShowDateChangeModal(false);
  };

  const handleUnassignRetakeClick = () => {
    setOpenUnAssignConfirmationModal(true);
  };

  const handleUnassignSaveClick = async () => {
    var assignmentId = [...retakeResult].sort((a, b) => b.retakeVersion - a.retakeVersion)[0].assignmentId;
    var result = await unassignRetake({assignmentId: assignmentId, studentId: studentId});
    if (result.error)
    { 
      if(result.error.data)
        CustomToast(result.error.data.error, 'error');
      else
        CustomToast('Failed to unassign retake assignment', 'error');
      return;
    }
    CustomToast('Retake assignment unassigned ', 'success');
    loadRetakeResults();
    setOpenUnAssignConfirmationModal(false);
  };

  const handleCanManuallyAssign = async () => {
    setOpenManullyAssignConfirmationModal(true);
  };

  const handleManuallyAssignSaveClick = async () => {
    var assignmentId = [...retakeResult].sort((a, b) => b.retakeVersion - a.retakeVersion)[0].assignmentId;
    var result = await triggerManualRetake({assignmentId: assignmentId, studentId: studentId});
    if (result.error)
    { 
      if(result.error.data)
        CustomToast(result.error.data.error, 'error');
      else
        CustomToast('Failed to manually assign retake', 'error');
      return;
    }
    CustomToast('Retake manually assigned ', 'success');
    loadRetakeResults();
    setOpenManullyAssignConfirmationModal(false);
  };

  const getCreditScoreName = () => {
    switch (retryCreditId) {
    case 0: return 'No Credits';
    case 1: return 'Half Credits';
    case 2: return 'Full Credits';
    default: return '';
    }
  };

  const customTooltip = (
    <div>
      <div className='lockdown-tooltip-text'>
        <FontAwesomeIcon id="clickableTooltip" className="modal-title-icon" icon={faCircleQuestion} />
      </div>
      <ReactTooltip anchorSelect="#clickableTooltip" clickable className='z-index10 retake-title-tooltip' place="right">
        <Row>
          <Col className='col-6 d-flex justify-content-start gap-1 text-white'>
            <FontAwesomeIcon icon={faSitemap} style={{color:'#fff'}} />
            <div className=' text-white'>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://cl.castlelearning.com/Review/Documents/Castle%20Learning%20Automated%20Retakes%20Guide.pdf"
                className="text-decoration-underline text-white">
                     Retake Guid</a>
            </div>
          </Col>
          <Col className='col-6 d-flex justify-content-start gap-1'>
            <FontAwesomeIcon icon={faMessagesQuestion} style={{color:'#fff'}} />
            <div>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://cl.castlelearning.com/Review/Documents/Castle%20Learning%20Automated%20Retakes%20FAQ.pdf"
                className="text-decoration-underline text-white">
                      Retake FAQ
              </a>
            </div>
          </Col>
        </Row>
      </ReactTooltip>
    </div>);

  return (
    <>
      <Modal
        contentWidth="70%"
        isOpen={isOpen}
        titleName={<>Retake Results {/*<FontAwesomeIcon style={{ color: '#88CBF1', cursor: 'default' }} icon={faCircleQuestion} />*/}</>}
        onClose={onClose}
        customTooltip={customTooltip}>
        <div className="d-flex flex-column">
          <div className="header">
            <div>
              <div><span>Student:&nbsp;</span><b>{studentName}</b></div>
              <div className='mt-2'><span>Correct on Retry Scoring:</span><b>{` ${getCreditScoreName()}`}</b></div>
            </div>
            <div>
              <div><span>Class:</span><b>{` ${className}`}</b></div>
            </div>
          </div><div className="d-flex flex-row align-items-center justify-content-between mt-3">
            <div>
              <div style={{ fontSize: '14px', fontWeight: '500' }} className='text-color'>Show score as</div>
              <Form.Group id="scoreAsRetakeRadio" className="mx-3" >
                <Form.Check inline label="Points" name="retakeScoreGroup" type="radio" id="pointsRetakeRadio" defaultChecked="true" onChange={() => setShowPoints(true)} />
                <Form.Check inline label="Percent" name="retakeScoreGroup" type="radio" id="percenRetaketRadio" onChange={() => setShowPoints(false)} />
              </Form.Group>
            </div>       
          </div>
          <div className='my-3'>
            {retakeResultStatus.isLoading && 
                  <>
                    <table className='table'>
                      <TableSkeleton
                        colCount={8}
                        rowCount={2} />
                    </table>
                  </>
            }
            {!retakeResultStatus.isLoading && <table className='table reportTable'>
              <thead>
                <tr>
                  <th>Assignment Version</th>
                  <th>Date Assigned</th>
                  <th className='fixed-header'>Date Started</th>
                  <th className='fixed-header'>Date Completed</th>
                  <th><FontAwesomeIcon icon={faCheck} className='fa-lg' /></th>
                  <th><FontAwesomeIcon icon={faXmark} className='fa-lg' /></th>
                  <th><FontAwesomeIcon icon={faXmark} className='fa-lg' /><FontAwesomeIcon icon={faCheck} className='fa-lg' /></th>
                  <th>CR Answered</th>
                  <th>Score</th>
                </tr>
              </thead>
              <tbody>
                {retakeResult.map((item, index) => {
                  return (
                    <tr key={`assignmentResult_${index}`}>
                      <td className='text-center'>{!item.retakeVersion || item.retakeVersion == 0  ? 'Original' : `Retake ${item.retakeVersion}`}</td>
                      <td className='text-center'>{item.dateAssigned ? new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(item.dateAssigned)).replace(/\//g, '-') : ''}</td>
                      <td className='text-center'>{item.dateStarted ? DateFormatter.toLongDateTime(item.dateStarted): ''}</td>
                      <td className='text-center'>{item.dateCompleted ? DateFormatter.toLongDateTime(item.dateCompleted)
                        :<span className='text-danger fw-bold"'>{item.timedOut
                          ? 'Timed Out!'
                          : (item.pastDue? 'Past Due!' : '')}</span> }</td>
                      <td className='text-center'>{item.correctCount}</td>
                      <td className='text-center'>{item.incorrectCount}</td>
                      <td className='text-center'>{item.correctOnRetryCount}</td>
                      <td className='text-center'>{item.crAnsweredCount}</td>
                      <td className='text-center'>{item.displayScore}</td>
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan={8} className="text-end fw-semibold">Accumulated Retake Score :</td>
                  <td className="text-center fw-semibold">{showPoints?accumulatedRetake:accumulatedScorePercentage}</td>
                </tr>
              </tbody>
            </table>
            }
          </div>
          <div className='d-flex gap-2 justify-content-between'>
            <button className='reportButton d-flex gap-2' disabled={!canManuallyAssign} onClick={()=> handleCanManuallyAssign()} >
              <div className='icon'>
                <FontAwesomeIcon className='fa-lg' color="#82A9E2" icon={faClockRotateLeft} />
              </div>
            Manually Assign Automated Retake
              <OverlayTrigger
                key={'assignment-options'}
                placement="right"
                overlay={
                  <Tooltip className="retake-result-tooltip">
                    <div className='tooltip-Content'>
                      <p>The <strong>Manually Assign Automated Retake</strong> function allows you to trigger the retake process for a student if the student’s most recent assignment meets the following criteria:</p>
                      <ul>
                        <li>i) The assignment was assigned with either Availability set to a date range or the Timed option checked (or both).</li>
                        <li>ii) The student started the assignment but did not complete it within the availability dates and/or before the assignment timed out.</li>
                      </ul>

                      <p>Click <strong>Manually Assign Automated Retake</strong> to trigger an Automated Retake for this student (if eligible).</p>

                      <p>Please note that if the assignment was assigned with Retake Availability set to a Date Range and the current date and time is past the End Date available for retakes, the student will not be eligible for a Manual Assign.</p>

                      <p>If you used the Change Date From/To option for this individual Automated Retake, it will not update the original Retake Settings for the assignment. If the original retake dates are past due, the student will not be eligible for Manual Assign. To change the retake dates for the assignment overall, please go to Assignment Results and use the Change Mode option.</p>
                    </div>
                  </Tooltip>
                }>
                <FontAwesomeIcon className="circle-question fa-lg" icon={faCircleQuestion} />
              </OverlayTrigger>
            </button>
            <button className='reportButton d-flex gap-2' disabled={!canChangeDate} onClick={() => handleChangeDateClick()}>
              <div className='icon'>
                <FontAwesomeIcon className='fa-lg' color="#82A9E2" icon={faCalendarAlt} />
              </div>
            Change Date From/To 
              <OverlayTrigger
                key={'assignment-options'}
                placement="top"
                overlay={
                  <Tooltip className="additional-options-tooltip">
                    <div>
                      <p>If an Automated Retake has a date range and you would like to extend the dates to give this student more time to complete it, click the <strong>Change Date From/To</strong> button.
                       You may then select new dates and click Save to update the retake dates. Please note that updating the dates for this Automated Retake will not modify the dates applied to any future Automated Retakes that are created.
                        This applies only to assignments where the retake availability is set to From/To.</p>
                      <p>You cannot change dates for the Original Assignment from this tab. If you would like to change the dates for the Original Assignment, please go to the Assignment Results tab and use the Change Mode option.</p>
                    </div>
                  </Tooltip>
                }>
                <FontAwesomeIcon className="circle-question fa-lg" icon={faCircleQuestion} />
              </OverlayTrigger>
            </button>
            <button className='reportButton d-flex gap-2' disabled={!canUnassign} onClick={() => handleUnassignRetakeClick()}>
              <div className='icon'>
                <FontAwesomeIcon className='fa-lg' color="#82A9E2" icon={faUserMinus} />
              </div>
            Unassign Retake Assignment
              <OverlayTrigger
                key={'assignment-options'}
                placement="top"
                overlay={
                  <Tooltip className="additional-options-tooltip">
                    <div>
                      <p>
                          This option allows you to unassign the most recent Automated Retake for this student, provided it has not been completed.
                          Unassigning the most recent Automated Retake will stop the retake process and it cannot be re-initiated.
                          You cannot unassign the Original Assignment from this tab.
                          To unassign the Original Assignment and all related Automated Retakes, please go to the Assignment Results tab and use the Unassign option.
                      </p>
                    </div>
                  </Tooltip>
                }>
                <FontAwesomeIcon className="circle-question fa-lg" icon={faCircleQuestion} />
              </OverlayTrigger>
            </button>
            <button className='reportButton d-flex gap-2' onClick={() => navigate('../reports/student_retake_report', {state:{studentId: studentId, selectedClassId: classId, retryCreditId: retryCreditId}})}>
              <div className='icon'>
                <FontAwesomeIcon color="#82A9E2" icon={faChartArea} />
              </div>
            Student Retake Report
            </button> 
          </div>
        </div>

      </Modal>

      <Modal
        contentWidth={'340px'}
        isOpen={showDateChangeModal}
        titleName="Change Date From/To"
        onClose={() => setShowDateChangeModal(false)}>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column">
            <div className="mb-3">
              <label className="form-label">Date From:</label>
              {getDateStatus.isLoading ? <Skeleton className='h-40'/> :   
                <div className='date-time-picker datetime-picker-container'>
                  <DateTimePicker
                    onChange={fromDateOnChange}
                    value={fromDate}
                    format="MM/dd/yyyy h:mm a"
                    className="d-flex"
                    calendarClassName="s-date-calendar"
                    id="initial-from-date-picker"
                    disableClock={true}
                  />
                </div>
              }
            </div>
            <div className="mb-3">
              <label className="form-label">Date To:</label> 
              {getDateStatus.isLoading ? <Skeleton className='h-40'/> :    
                <div className='date-time-picker datetime-picker-container'>
                  <DateTimePicker
                    onChange={toDateOnChange}
                    value={toDate}
                    format="MM/dd/yyyy h:mm a"
                    className="d-flex"
                    calendarClassName="s-date-calendar"
                    id="initial-from-date-picker"
                    disableClock={true}
                  />
                </div>
              }
            </div>
          </div>  
          <div className="d-flex justify-content-end mt-3">
            <button className="btn btn-castleGray me-2" disabled={getDateStatus.isLoading} onClick={() => setShowDateChangeModal(false)}>Cancel</button>
            <button className="btn btn-castleRed" disabled={getDateStatus.isLoading || updateDateStatus.isLoading} onClick={()=> handleDateChangeSave()}>Change</button>
          </div>
        </div>
      </Modal>

      <ConfirmationModal
        isOpen={openUnAssignConfirmationModal}
        onClose={()=> setOpenUnAssignConfirmationModal(false)}
        contentWidth={'630px'}
        onSave={()=> handleUnassignSaveClick()}
        buttonPosition={'center'}
        confirmButton={'Yes'}
        confirmationInProgress={unassignRetakeStatus.isLoading}
        cancelButton={'No'}
        showIcon={false}
        successNotification={false}
        titleName={'Unassign Retake Assignment'}       
      >
        <div>
         Are you sure you want to unassign the retake assignment for this student?
        </div>
        <div className='fw-semibold mt-4 mb-3'>
          Note: you will no longer be able to view their results if student started the assignment.
        </div>
      </ConfirmationModal>

      <ConfirmationModal
        isOpen={openManullyAssignConfirmationModal}
        onClose={()=> setOpenManullyAssignConfirmationModal(false)}
        contentWidth={'630px'}
        onSave={()=> handleManuallyAssignSaveClick()}
        buttonPosition={'center'}
        confirmButton={'Yes'}
        confirmationInProgress={triggerManualRetakeStatus.isLoading}
        cancelButton={'No'}
        showIcon={false}
        successNotification={false} 
        titleName={'Manually Assign Automated Retakes'}
      >
        <div>
         Are you sure you want to trigger retake manually for this student?
        </div>
      </ConfirmationModal>
    </>
  );
}

RetakesModal.propTypes = {
  studentId: PropTypes.any,
  studentName: PropTypes.string,
  classId: PropTypes.any,
  className: PropTypes.string,
  retryCreditId : PropTypes.number,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  accumulatedRetake: PropTypes.string,
  accumulatedScorePercentage: PropTypes.string,
  originalAssignmentId: PropTypes.any,
  calculateOriginalScore: PropTypes.func
};


export default RetakesModal;